//Romanian
export default  {
    homeScreen : {
        startConversation: 'Începeți o conversație',
        newConversationButton: 'OBȚINE AJUTOR',
        newMessageButton: '+ Mesaj nou',
        allTopics: 'Toate subiectele',
        allChatsButton: 'Vezi toate',
        poweredBy: 'Cu sprijinul Richpanel',
        reOpenConversation: 'Redeschideți conversația',
        recentConversations: 'Conversațiile tale',
        startAChat: 'Porniți conversația',
        noRecentConversations: 'Nu există conversații recente',
        noRecentOrders: 'Nu există comenzi recente',
        haveAQuestion: "Ai o întrebare sau vrei doar să spui salut? Ne-ar plăcea să auzim de la tine.",
        conversationClosed: `Această conversație a fost marcată drept închisă.`,
        retry: 'Reîncercați',
        errorOccured: 'A apărut o eroare la procesarea cererii.',
        successMessage: 'Am primit solicitarea dvs., iar echipa urmează să vă contacteze în curând {e-mail}',
        loadingMessage: 'Vă rugăm așteptați. Se trimite solicitarea.',
        goHome: 'OKAY',
        sendUsMessage: 'Trimite-ne un mesaj',
        endChat: 'INCHEIEREA CONVORBIRII',
        goto: 'Mergi la',
    },

    loginScreen: {
        title: 'Accesați contul dvs.',
        titleForOrdersScreenForward: 'Conectați-vă pentru a vizualiza comenzile',
        userIdFieldTitle: "Telefonul sau e-mailul",
        userIdFieldPlaceHolder: "Introduceți telefonul / adresa de e-mail",
        sendCode: "Introduceti",
        enterCode: 'Introduceți codul pe care l-am trimis',
        enterTheCode: 'Introduceti codul',
        notYourUserId: 'Nu este {userIdType} dvs.?',
        userIdTypes: {
            'phone': 'număr de telefon',
            'email': 'email',
        },
        change: 'Schimbă',
        notReceivedCode: "Dacă nu ați primit codul?",
        resendCode: 'Retrimite',
        in: 'in',
        verifyCode: 'VERIFICA',
        logout: 'Deconectează-te',
        orderNumberFieldTitle: 'Numărul comenzii dvs. ',
        orderNumberFieldPlaceholder: 'Introduceți numărul de comandă Ex: 1234',
        zipcodeFieldTitle: 'Codul dvs. poștal',
        zipcodeFieldPlaceholder: 'Introduceți codul poștal',
        emailFieldTitle: 'Email',
        emailFieldPlaceholder: 'Introduceți adresa de email',
    },

    orderList : {
        reorder: 'COMANDĂ DIN NOU',
        getHelp: 'OBȚINE AJUTOR',
        startNewConversation: '+ÎNCEPEȚI O CONVERSAȚIE NOUĂ',
        viewPreviousOrder:'VEZI TOATE COMENZILE',
        seeAll: 'Vezi toate',
        viewMoreOrders: 'VEZI MAI MULTE COMENZI',
        viewOrderStatus: 'VEZI STAREA COMENZII',
        chatWithUs: 'VORBESTE CU NOI',
        issueWithPreviousOrder:'AJUTOR CU O COMANDĂ ANTERIORĂ' ,
        orderLabel: 'Comanda',
        help: 'AJUTOR',
        lastOrder: 'Ultima comanda',
        selectRelevantItems: 'Selectați produsele relevante',
        selectItemsErrorMsg: 'Vă rugăm să selectați elementele pentru a continua',
        selectAll: 'Selectează tot',
        selectQuantity: 'Câte produse?',
        helpWithThisOrder: 'Ajutor cu această comandă',
        yourOrders: 'Comenzile tale',
        view: 'VIZUALIZARE',
        track: 'URMĂREȘTE',
        addressTitle: 'rezumat',
        billingAddressTitle: 'ADRESA DE FACTURARE',
        shippingAddressTitle: 'ADRESA DE TRANSPORT',
        receiptTitle: 'produse',
        itemTotal: 'Total produse',
        taxes: 'Taxe',
        discounts: 'Romanian',
        giftCard: 'Gift Card', 
        deliveryCharges: 'Taxe de transport',
        total: 'Total',
        loginToViewOrders: 'Client existent?',
        loginSuggestion: "Obțineți ajutor cu o comandă",
        trackingOrderLabel: 'Urmărește comanda',
        shipmentDescription: "Reveniți la această pagină pentru actualizări privind starea expedierii",
        free: "gratis",
        selectedItems: "Produse selectate",
        items: "produse",
        "orderSearchPlaceholder": 'Filtrează după comandă #',
        "noOrderFound": 'Nu se potrivesc comenzi {orderId}',
    },
    chatListScreen: {
        header: 'Conversațiile tale',
    },
    sentences: {
        "IN_A_DAY" : "Echipa răspunde de obicei într-o zi.",
        "IN_FEW_MINUTES": "Echipa răspunde de obicei în câteva minute.",
        "IN_FEW_HOURS": "Echipa răspunde de obicei în câteva ore.",
        "AS_SOON_AS_THEY_CAN": "Echipa va răspunde cât mai curând",
        "BACK_ON": "Înapoi pe",
        "BACK_IN": "Înapoi în ",
        "HOURS": "ore",
        "MINUTES": 'Minute',
        provideBelowDetails: "Vă rugăm să furnizați detaliile de mai jos",
    },
    inputFields: {
        submitted: 'trimis'
    },
    inputPropDisplayNames: {
        "email": "Email",
        "phone": "Telefon",
        "Phone": "Telefon",
        "firstName": "Nume",
        "lastName": "Prenume",
        "uid": "Numele de utilizator",
        "campaign": "UTM Campaign",
        "medium": "UTM Medium",
        "googleplus": "Google plus",
        "shippingPhone": "Telefon pentru livrare",
        "source": "UTM Source",
        "lastOrderAt": "Timpul ultimei comenzi",
        "firstOrderAt": "Timpul primei comenzi",
        "visits": "Sesiuni",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "updatedAt": "Vazut ultima data",
        "createdAt": "Vazut prima data",
        "linkedin": "Linkedin",
        "instagram": "Instgram",
        "pinterest": "Pinterest",
        "tumblr": "Tumblr",
        "billingEmail": "Email de facturare",
        "billingPhone": "Telefon pentru facturare",
        "shippingEmail": "Email pentru livrare",
        "state": "Stat",
        "city": "Oraș",
        "country": "Județ",
        "deviceType": "Tip de dispozitiv",
        "browserName": "Numele browserului",
        "osName": "Numele Os",
        "platform": "platforma",
        "ltv": "CLV",
        "ordersCount": "Numărul comenzilor",
        "name": "Nume",
        "RichpanelPredictedCLV": "Predicted CLV",
        "RichpanelAliveProbability": "Likelihood To Buy",
        "RichpanelNextOrderDate": "Data comenzii următoare",
        "RichpanelPredictedOrderCount": "Număr de ordine prevăzut",
        "aov": "AOV",
        "WebsiteURL":"Website URL"
    },
    botMessages: {
        EXISITING_CUSTOMER: 'Sunteti deja client?',
        YES_EXISITING_CUSTOMER: "Da, sunt client",
        NO_EXISITING_CUSTOMER: "Nu, încă nu sunt client",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "Oferă echipei o modalitate de a ajunge la tine.",
        YOU_WILL_BE_NOTIFIED_EMAIL: "Veți fi anunțați aici și pe e-mail ({email}) atunci când primiți un răspuns.",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "Veți fi anunțați aici când vor răspunde.",
        LEAVE_YOUR_MESSAGE: "Vă rugăm să lăsați mesajul",
        TEAM_WILL_BE_BACK_IN:"Echipa va reveni peste {hours} ore",
        TEAM_WILL_BE_BACK_ON:"Echipa va reveni {availableAt}",
        FEW_MORE_DETAILS: "Vă mulțumim! Mai multe detalii vă vor ajuta să vă atribuiți persoanei potrivite:",
    },
    initialForm: {
        heading: 'Vă rugăm să introduceți detaliile pentru a începe conversația',
        startChat: 'Incepe conversația'
    },
    customerJourneyPreChatForm: {
        heading: 'Începeți o discuție',
        startChat: 'Incepe conversatia',
        proceed: 'Continuă',
        canWeHelpWithAnythingElse: 'Vă putem ajuta cu altceva?',
        noThanks: "Ok, vă mulțumesc",
        yesContactSupport: "Chat with support",
        contactSupport: "Asistență de contact",
        yes: 'da',
        no: 'Nu',
    },
    rating: {
        askedHeader: 'Evaluează-ți conversația',
        successHeader: 'Ați evaluat această conversație',
        thanksMessage: "Vă mulțumim pentru că ne-ați anunțat",
        placeholderForRatingFeedback: "Vă rugăm să scrieți feedback-ul"
    },
    placeholders: {
        emojiSearch: 'Search Emojis',
        typeAMessage: 'Scrie un mesaj',
        searchGifs: 'Search GIFs',
    },
    lastMessageText: {
        sentAGif: 'Am trimis un GIF',
        sharedFile: 'A trimis un fișier',
        askedForQualificationDetails: 'Am cerut detalii despre calificare.',
        askedForRating: 'Am cerut evaluarea',
        askedForFeedback: 'Am cerut feedback',
        sharedOrderSummary: "Rezumatul comenzii partajate"
    },
    greetingAnimation: {
        weAreOnline: 'Suntem online',
        askUsAnything: 'Întreabă-ne orice',
        chatWithUs: 'Vorbește cu noi'
    }
}